import router from '@/plugins/Router'
import { setWithExpiry, getWithExpiry } from "@/libs/Helpers";

const module = {
    namespaced: true,
    state: () => ({
        data: {},
        nationalID: null,
        pin: null,
        time: null,
        sessionTime: 3600000 // 1 saat
    }),
    getters: {
        getData(state) {
            return state.data
        },
        getStatus(state){
            return state.data && state.data.status ? state.data.status:null;
        },
        getNationalID(state) {
            return state.nationalID
        },
        getPin(state) {
            return state.pin
        },
        getTime(state) {
            return state.time
        },
        getSessionTime(state) {
            return state.sessionTime
        }
    },

    mutations: {
        setData(state, payload) {
            const data = payload?.data !== undefined ? payload.data : payload;
            const ttl = payload?.ttl !== undefined ? payload.ttl : state.sessionTime;
            state.data = data;
            setWithExpiry('bisep_app_data', state.data, ttl, true);
        },
        setStatus(state, payload) {
            const status = payload?.status !== undefined ? payload.status : payload;
            const ttl = payload?.ttl !== undefined ? payload.ttl : state.sessionTime;
            state.data.status = status;
            setWithExpiry('bisep_status_data', state.data, ttl, true);
        },
        setNationalID(state, payload) {
            const nationalID = payload?.nationalID !== undefined ? payload.nationalID : payload;
            const ttl = payload?.ttl !== undefined ? payload.ttl : state.sessionTime;
            state.nationalID = nationalID;
            setWithExpiry('bisep_app_id', state.nationalID, ttl, true);
        },
        setPin(state, payload) {
            const pin = payload?.pin !== undefined ? payload.pin : payload;
            const ttl = payload?.ttl !== undefined ? payload.ttl : state.sessionTime;
            state.pin = pin;
            setWithExpiry('bisep_app_pin', state.pin, ttl, true);
        },
        setTime(state, payload) {
            const time = payload?.time !== undefined ? payload.time : payload;
            const ttl = payload?.ttl !== undefined ? payload.ttl : state.sessionTime;
            state.time = time;
            setWithExpiry('bisep_app_time', state.time, ttl, true);
        },
        clearData(state) {
            state.data = {}
            state.nationalID = null
            state.pin = null
            localStorage.removeItem('bisep_app_data')
            localStorage.removeItem('bisep_app_id')
            localStorage.removeItem('bisep_app_pin')
            localStorage.removeItem('bisep_app_time')
            localStorage.removeItem('bisep_status_data')
            localStorage.removeItem('bisepSessionDeadline')
            localStorage.removeItem('tabIndex')
        }
    },

    actions: {
        initData({commit}) {
            let data = getWithExpiry('bisep_app_data', true)
            let nationalID = getWithExpiry('bisep_app_id', true)
            let pin = getWithExpiry('bisep_app_pin', true)
            let time = getWithExpiry('bisep_app_time', true)
            if (data && nationalID && pin) {
                commit('setData', data)
                commit('setNationalID', nationalID)
                commit('setPin', pin)
                commit('setTime', time)
            }
        },
        isLogin({state}) {
            let data = state.data;
            let nationalID = state.nationalID;
            let pin = state.pin;
            if (!data || !nationalID || !pin) {
                router.push('/bisep/application/login')
            }
        },
        isLoginGoIndex({state}) {
            let data = state.data;
            let nationalID = state.nationalID;
            let pin = state.pin;
            if (data && nationalID && pin) {
                router.push('/bisep/application/form')
            }
        },
        logout({commit}) {
            commit('clearData')
            router.push('/bisep/application/login')
        }
    }
}

export default module;
